<bz-date-picker appBringozIdGenerator="bringozDatePicker"
                size="sm"
                [label]="isHideLabel ? '' : ((placeholder || 'Enter date') | translate)"
                [placeholder]="(placeholder || 'Enter date') | translate"
                [ariaLabel]="(placeholder || 'Enter date') | translate"
                [clearLabel]="'Clear' | translate"
                [openLabel]="'Open calendar' | translate"
                [format]="dateFormat"
                [value]="day"
                [min]="minDay"
                [max]="maxDay"
                [filter]="dayFilter"
                [clearable]="isAllowClear"
                [disabled]="isDisabled"
                (valueChange)="onDayChange($event)">
</bz-date-picker>

@if (isRequired && isTouched && !day) {
  <div class="invalid-feedback d-block">{{ 'This field is required' | translate }}</div>
}
